import { type EdgeProps } from '@xyflow/react'
import { FlowCustomEdge } from 'widgets/Flow'
import { useSmartCallFlowBuilderContext } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/context'
import { getActions } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/CustomEdge/getActions'
import { AddActionDropdownContent } from './AddActionDropdownContent/AddActionDropdownContent'

export function CustomEdge(props: EdgeProps & { viewOnly?: boolean; disabled?: boolean }) {
  const { source, target } = props

  const { getActionById } = useSmartCallFlowBuilderContext()

  const actions = getActions({ getActionById, source, target })

  return (
    <FlowCustomEdge
      {...props}
      noActions={!actions.length}
      Content={(props) => <AddActionDropdownContent actions={actions} {...props} />}
    />
  )
}
